const [TRUE] = require("../private/arrayOfAllBooleans")
const constant = require("./constant"),
  stubTrue = constant(TRUE)

module.exports = stubTrue